import * as React from 'react';
import { Box, Paper } from '@mui/material';
import { useState } from 'react';

import {
    StyledCustomerSatScoreGroup,
    StyledCustomerSatScore,
    StyledCustomerSatScoreRadio,
} from './StyledSurveyComponents';

import SurveyStarIcon from 'modules/common/components/Icons/SurveyStarIcon';

function ScoreScaleLabel({
    score,
    currentValue,
    hoveredValue,
}: {
    score: number;
    currentValue: number | null;
    hoveredValue: number | null;
}) {
    let shouldFill = false;

    if (hoveredValue !== null) {
        shouldFill = hoveredValue >= score;
    } else if (currentValue !== null && currentValue >= score) {
        shouldFill = true;
    }

    return (
        <Box aria-label={`${score} stars`} sx={{ position: 'relative', display: 'inline-block' }}>
            <SurveyStarIcon
                fill={shouldFill ? 'green.400' : 'cement.400'}
                sx={{
                    width: 40,
                    height: 40,
                    cursor: 'pointer',
                    position: 'relative',
                    zIndex: 2,
                    '& path': {
                        transition: 'fill 0.1s ease-in-out',
                    },
                }}
            />
        </Box>
    );
}

export default function CustomerSatScoreScale({
    onChange,
    name,
    ariaLabel,
    value,
    start,
    end,
}: {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    ariaLabel: string;
    value: string | null;
    start: { score: number; label: string };
    end: { score: number; label: string };
}) {
    const [hoveredValue, setHoveredValue] = useState<number | null>(null);
    const scoreOptions = Array.from({ length: end.score - start.score + 1 }, (_, index) => start.score + index);
    return (
        <Paper variant="filled" sx={{ paddingX: { xs: 2, sm: 4 }, paddingY: 3, width: '100%' }}>
            <StyledCustomerSatScoreGroup aria-labelledby={ariaLabel} name={name} value={value} onChange={onChange}>
                {scoreOptions.map((option) => (
                    <StyledCustomerSatScore
                        key={option}
                        value={option}
                        label={
                            <ScoreScaleLabel
                                score={option}
                                currentValue={value ? Number(value) : null}
                                hoveredValue={hoveredValue}
                            />
                        }
                        control={<StyledCustomerSatScoreRadio />}
                        onMouseEnter={() => setHoveredValue(option)}
                        onMouseLeave={() => setHoveredValue(null)}
                    />
                ))}
            </StyledCustomerSatScoreGroup>
        </Paper>
    );
}
